module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-tip"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": _vm.placement
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.tips), function(item) {
    return _c('p', {
      staticClass: "tip"
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  })), _vm._v(" "), _c('i', {
    class: _vm.iconClass
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e9f0f64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FontTip/FontTip.vue
// module id = 747
// module chunks = 8